import type { Exchange } from 'urql'
import { map, pipe } from 'wonka'
import { transformResponse } from './transformPermittedField'

export const responseTransformer: Exchange = ({ forward }) => {
  return (ops$) => {
    return pipe(
      ops$,
      forward,
      map((result) => {
        if (result.data) {
          try {
            result.data = transformResponse(result.data)
          } catch (error) {
            console.warn('Error transforming response:', error)
          }
        }

        return result
      })
    )
  }
}
